<template>
  <div class="main_projects">
    <div class="centered">

    
    <!-- <Popup v-model="change_status_popup">
        <template #content>
        <div id="update_status">
            <div class="inner">
                <h3>שינוי סטטוס המכרז</h3>
                <ul>
                    <li>
                        <input type="radio"> 
                        <label for="">בהכנה</label>
                    </li>
                    <li>
                        <input type="radio"> 
                        <label for="">קבלת הצעות</label>
                    </li>
                    <li>
                        <input type="radio"> 
                        <label for="">נסגר</label>
                    </li>
                    <li>
                        <input type="radio"> 
                        <label for="">שקלול הצעות</label>
                    </li>
                    <li>
                        <input type="radio"> 
                        <label for="">הסתיים</label>
                    </li>
                </ul>
            </div>
        </div>
        </template>

       <template #actions>
        <a class="md-primary" @click="close">סגירה</a> 
      </template>
    </Popup> -->
    <breadcrumbs :items="[{label: 'רשימת מכרזים', path: '/projects_manager'}]" />
    <div class="head">
        <h1>רשימת מכרזים</h1>
        <router-link to="create_project" class="add_prj btn">
            <span class="icon page_icon" v-if="!is_mobile()"></span>
            <span class="icon plus_icon" v-else></span>
            <span >יצירת מכרז חדש</span>
        </router-link>
    </div>

    <ul class="projects">
        <prjCard @deleteProject="deleteProject" @duplicateProject="duplicateProject" v-for="item in itemsComp" :item="item" :key="item.id"/>
    </ul>
</div>
  </div>
</template>

<script>
import prjCard from '@/components/prjCard.vue'
import Breadcrumbs from '@/components/Breadcrumbs.vue'

export default {
    components: {prjCard, Breadcrumbs},
    data() {
        return {
            items: [],
            filters: {
                projects_type: 'all',
                inputOrder: '',
                inputFilter: '',
            },
            change_status_popup: false,
            itemIdEdited: 0,
            textOpen:false,
        }
    },
    mounted() {
        this.init()
    },
    beforeMount(){
      const res = this.checkPerms();
      if(!res || res == 'entrepreneur'){
        this.$router.push('/');  
      }
    },
    methods: {
        init() {
            this.api({ action: 'projects/results'}, (data) => {
                console.log(data);
                this.items = data.data.items;
                // this.items = [...data.data.items,...data.data.items,...data.data.items,...data.data.items];
            })
        },
        deleteProject(id) {
            this.api({ action: 'projects/delete', data: {id}}, (data)=>{
                if (data.data) {
                    this.init()
                }
            })
        },
        duplicateProject(id) {
            this.api({ action: 'projects/duplicate', data: {id}}, (data)=>{
                if (data.data) {
                    this.init();
                }
            })
        },
        toggleIcon() {
            this.textOpen = !this.textOpen;
        },
    },
    computed: {
        itemsComp() {

            let res = [] 
            // if (this.filters.inputOrder === 'tender_end_date') {
            //     return this.items.sort((a, b) => a.tender_end_date - b.tender_end_date);
            // }
            res = this.items;
            return res
        },
    }
}
</script>

<style lang="scss" scoped>
.main_projects {background: var(--pageBG);

    #update_status {}


    .head {display: flex; justify-content: space-between; margin-bottom: 20px;
        
        h1 { font-size: var(--h2); font-weight: bold; 
             @include mobile {
                font-size: 30px;
            }
        }
        .btn { width: fit-content; }
        // .add_prj { cursor: pointer; display: flex; align-items: center; justify-content: center; padding: 10px 30px; border: 1px solid #333; border-radius: 8px;}
    }

    .projects { display: flex; flex-direction: column; gap: 20px;
        @include mobile {
            padding : 8px;
        }
    }
}

@media (max-width: 768px) {
    .main_projects {
        overflow-x: hidden;
        .projects {
            padding: 0 10px;
            align-self: center;
        }
         .head{
                padding:  10px;
                display: flex;
                flex-direction: column;

                h1{
                   font-size: 28px; 
                   width: 50%;
                   height: fit-content;
                }
                .add_prj{
                    padding: 10px;
                    height: fit-content;
                    margin-top: 0px;
                    align-self:flex-start ;
                    position: fixed;
                    bottom: 20px;
                    right: 15px;
                    gap:2px;
                    border-radius: 50%;
                    z-index: 10000000;
                    
                    .plus_icon{ background-image: url( ../assets/file-add.png); 
                        width: 25px; 
                        height: 25px; 
                        display: flex;
                    }
}
                    
                    .page_icon{
                        width: 20px;
                        height: 20px;
                        display: flex;
                    }
                    span{
                        display: none;
                    }
                    .span.active{
                        display: block;
                    }
                    
                
            }
        
        .centered {
          :deep(.breadcrumbs__item){
                font-size: 16px;
                margin-right: 5px;
            }
           
            width: 100%;
        }
    }
}
</style>